




import Vue from 'vue';
export default Vue.extend({
  name: 'Divider',
  props: {
    thickness: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    thicknessInPx(): string {
      return `${this.$props.thickness}px`;
    },
  },
});
